import { render } from "./TwoColumnLayout.vue?vue&type=template&id=cfa6e26c&scoped=true"
import script from "./TwoColumnLayout.vue?vue&type=script&lang=js"
export * from "./TwoColumnLayout.vue?vue&type=script&lang=js"

import "./TwoColumnLayout.vue?vue&type=style&index=0&id=cfa6e26c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa6e26c"]])

export default __exports__